
import React from 'react';
import { NodeResizer } from '@xyflow/react';

interface NodeData extends Record<string, unknown> {
  label: string;
  uuid: string;
  backgroundColor?: string;
}

export function LabeledGroupNode({ data, selected }: { data: NodeData, selected: boolean }) {
  return (
    <>
      <NodeResizer 
        minWidth={220} 
        minHeight={160} 
        isVisible={selected}
        handleStyle={{
          backgroundColor: '#6366F1',
          border: '3px solid white',
          borderRadius: '4px',
          width: '10px',
          height: '10px'
        }}
        lineStyle={{
          backgroundColor: '#6366F1',
          opacity: 0.6,
          borderRadius: '2px'
        }}
      />
      <div 
        className="w-full h-full border-2 border-dashed border-gray-400 backdrop-blur-sm rounded-2xl relative"
        style={{
          backgroundColor: (data.backgroundColor as string) || 'rgba(255, 255, 255, 0.6)'
        }}
      >
        <div className="absolute top-3 left-4 text-gray-700 text-sm font-semibold bg-white/90 px-3 py-1 rounded-lg border border-gray-300">
          {data.label}
        </div>
      </div>
    </>
  );
}
